import type { WorkflowBinding, WorkflowTemplateResource } from '../../services/workflowsApi.ts';

/** Illustrative form values, never contact data or a runnable message. */
export const workflowFormExamples: Record<string, string> = {
  name: 'Ana', phone: '(11) 99999-0000', email: 'ana@example.test',
  interest: 'Avaliação', message: 'Gostaria de conhecer o tratamento.',
  source_id: 'origem-exemplo', external_id: 'referência-exemplo', tags: 'Exemplo',
};

export interface WorkflowTemplatePreviewContent {
  header: { format: string; text: string } | null;
  body: string;
  footer: string;
  buttons: { index: number; type: string; text: string }[];
  advanced: boolean;
}

export function getWorkflowTemplatePreview(template: WorkflowTemplateResource, bindings: Record<string, WorkflowBinding> = {}): WorkflowTemplatePreviewContent {
  const components = template.components || [];
  const header = components.find(c => c.type === 'HEADER');
  const body = components.find(c => c.type === 'BODY');
  const footer = components.find(c => c.type === 'FOOTER');
  const replace = (text: string, part: 'header' | 'body', examples: string[] = []) => text.replace(/\{\{([1-9]\d*)\}\}/g, (original, parameter) => {
    const binding = bindings[`${part}.${parameter}`];
    if (binding?.source === 'form_field') return workflowFormExamples[binding.value] || '[Campo do formulário]';
    if (binding?.source === 'literal') return binding.value || original;
    return examples[Number(parameter) - 1] || original;
  });
  return {
    header: header ? { format: header.format || 'TEXT', text: replace(header.text || '', 'header', header.example?.header_text) } : null,
    body: replace(body?.text || 'Selecione um template aprovado para visualizar a mensagem.', 'body', body?.example?.body_text?.[0]),
    footer: footer?.text || '',
    buttons: (components.find(c => c.type === 'BUTTONS')?.buttons || []).map((button: any, index: number) => ({ index, type: button.type || '', text: button.text || 'Botão aprovado' })),
    advanced: components.some(c => !['HEADER', 'BODY', 'FOOTER', 'BUTTONS'].includes(c.type)),
  };
}
